import { render } from "./cd-glazing.vue?vue&type=template&id=bf3c9054"
import script from "./cd-glazing.vue?vue&type=script&lang=js"
export * from "./cd-glazing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__